export default "__VITE_ASSET__CHjg2C3___"